import React, { useState, useEffect } from "react";
import style from "../../style/DutySchedule.module.scss";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import PenToSquareRegular from "../Icon/PenToSquareRegular";
import dayjs from "dayjs";
import Logger from "../../libraries/Logger";
import DoctorDetailModal from "../Modal/DoctorDetailModal";
import { DoctorScheduleList } from "../../Data/DoctorScheduleList";

function DutyDayScheduleListBody({ data }) {
  const [isOtherHospital, setIsOtherHospital] = useState(null);
  const [open, setOpen] = useState([]);
  const [cursor, setCursor] = useState(false);
  useEffect(() => {
    setIsOtherHospital(
      JSON.parse(localStorage.getItem("auth"))?.IsOtherHospital
    );
  }, [isOtherHospital]);

  const getDay = (DayValue, index) => {
    if (DayValue.isName === false) {
      return <li className={style.day}>{DayValue.DoctorName}</li>;
    } else {
      return (
        <li className={style.day}>
          <a href="#" className={style.duty_person}>
            {DayValue.DoctorName}
          </a>
          <div className={style.duty_tel} key={index}>
            {DayValue.subListData?.map((value, subindex) => {
              return (
                <div className={style.tel} key={subindex}>
                  {value}
                </div>
              );
            })}
          </div>
        </li>
      );
    }
  };
  const theadContent = ["時段", "醫生"];

  // console.log(data);
  const dateArray = data?.DutyList.map((v) => {
    return { ...v, Date: new Date(v.Date) };
  });

  // console.log(dateArray);

  return (
    <div className={style.duty_info}>
      <div className={style.duty_calender}>
        <table className={style.table} style={{ tableLayout: "fixed" }}>
          <thead>
            <tr className={style.table_title}>
              {theadContent?.map((v, i) => {
                return (
                  <th
                    className={style.table_title_self}
                    key={i}
                    style={{ color: "#575757" }}
                  >
                    {v}
                  </th>
                );
              })}
            </tr>
          </thead>

          <tbody>
            <tr className={style.table_title}>
              <td className={style.table_body_self}>
                <div style={{ color: "#575757" }}>08至12</div>
                <div style={{ color: "#575757" }}>12至16</div>
                <div style={{ color: "#575757" }}>16至20</div>
                <div style={{ color: "#575757" }}>20至08</div>
              </td>
              {dateArray != null && dateArray.length > 0 ? (
                <td className={style.table_body_self}>
                  {dateArray[0].List?.map((v, i) => {
                    if (i < 4) {
                      return (
                        <div
                          style={{
                            cursor: cursor ? "no-drop" : "pointer",
                            color: " #1675e0",
                          }}
                          key={i}
                          onClick={() => {
                            if (v?.Name !== null) {
                              setOpen([
                                { open: true },
                                { title: "取栓值班醫師" },
                                { Identity: v?.Identity },
                                { name: v?.Name },
                                {
                                  number: [
                                    v?.PhoneNumber,
                                    v?.ShortNumber,
                                    v?.ExtensionNumber,
                                  ],
                                  time: [v?.StartDateTime, v?.EndDateTime],
                                },
                              ]);
                            }
                          }}
                          onMouseEnter={() => {
                            if (v?.Name === null) {
                              setCursor(true);
                            }
                          }}
                          onMouseLeave={() => {
                            setCursor(false);
                          }}
                        >
                          {v?.Name}
                        </div>
                      );
                    } else {
                      return "";
                    }
                  })}
                </td>
              ) : (
                <td className={style.table_body_self}>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </td>
              )}
            </tr>
          </tbody>
        </table>
      </div>

      <DoctorDetailModal open={open} setOpen={setOpen} />
    </div>
  );
}

export default DutyDayScheduleListBody;
